import React, { Component } from "react";
import SubNavBranding from "./SubNavBranding";
import Feature from "./Feature";
import "./category.css";
import { withRouter } from "react-router-dom";

const clients = [
  {
    id: "thai-chix",
    name: "Thai Chix",
    desc: "Thai Chix",
    features: [
      {
        id: 1,
        desc:
          "Thai Chix was founded by a group of university students, their goal was to have a food stall that sells delicious chicken dishes to those hungry students. Their university offers students to have their own stall in the campus but they would only provide limited number of official slots, therefore it is a competition to see who has the most profit before the contest ends.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542868649/rtds_work/Thai%20Chix/ThaiChix_TentPhotos_2.jpg"
      },
      {
        id: 2,
        desc:
          "We helped Thai Chix to stand from the rest. From their logos, branding, posters, banners and stall design.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542881378/rtds_work/Thai%20Chix/PlateThaiChix.jpg"
      },
      {
        id: 3,
        desc:
          "With these they are sure to have the most attractive stall from the rest.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542897226/rtds_work/Thai%20Chix/Apron-mockup.jpg"
      }
    ]
  },
  {
    id: "eatsinthewest",
    name: "Eats in the West",
    desc: "Eats in the West",
    features: [
      {
        id: 1,
        desc:
          "Eats in the west is a restaurant that has what the Filipino people craves for like American dishes as well as Filipino dishes. Best for families who wants to eat outside but can still have the taste of what home cooking is while having to eat variety of fast food dishes.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542896559/rtds_work/Eats%20in%20the%20West/menu-mockup0012.jpg"
      },
      {
        id: 2,
        desc:
          "Redtomato Design Studio gave them a new brand identity which includes their new logo to be used in their utensils and kitchen ware and other disposables. Craving for that Filipino cuisine but have kids around who wants to eat fast food?  Stop by on their restaurant, Eats in the West!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542887165/rtds_work/Eats%20in%20the%20West/Fries-Box-Mockup.jpg"
      }
    ]
  },
  {
    id: "omg",
    name: "Oil My Goodness",
    desc: "Oil My Goodness",
    features: [
      {
        id: 1,
        desc:
          "Oil My Goodness-OMG is an all-natural skincare brand that is here for one thing: to give people a better, healthier alternative. Since 2010, They have been an advocate of the power of mother nature when it comes to beauty.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542868779/rtds_work/OMG/Labels%20Stickers/OMG-Logo-with-variations_dark-bottle-contents-09.jpg"
      },
      {
        id: 2,
        desc:
          "Their products are made from fresh and natural ingredients mixed together to produce the desired natural goodness, which can also be seen in their brand logo.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542829426/rtds_work/OMG/IMG_5417.jpg"
      }
    ]
  },
  {
    id: "mashiso",
    name: "Mashiso",
    desc:
      "Mashiso Korean BBQ is a new restaurant with one goal in mind – to provide customers the authentic Korean BBQ experience made from fresh ingredients, sauces and marinades that has been passed down from generations. As a new restaurant that wants to create their own name, Red Tomato Design Studio made the restaurant's identity. We made their new branding and their logos that was made to entice their customers into their eating into their mouth watering restaurant! Make sure to come and visit them for that Korean authentic experience!",
    features: [
      {
        id: 1,
        desc:
          "Mashiso Korean BBQ is a new restaurant with one goal in mind – to provide customers the authentic Korean BBQ experience made from fresh ingredients, sauces and marinades that has been passed down from generations.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542868349/rtds_work/Mashiso/Mashiso_Logo-18.png"
      },
      {
        id: 2,
        desc:
          "As a new restaurant that wants to create their own name, Red Tomato Design Studio made the restaurant's identity. We made their new branding and their logos that was made to entice their customers into their eating into their mouth watering restaurant! Make sure to come and visit them for that Korean authentic experience!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542868412/rtds_work/Mashiso/Mashiso-Tarp-1.jpg"
      }
    ]
  }
];
class Branding extends Component {
  render() {
    const id = this.props.match.params.id;
    const selected = clients.filter((item, i) => item.id === id);
    return (
      <div className="web-systems">
        <div className="banner-container">
          <span className="banner-text">
            Can't have a business without a brand!
          </span>
          <div className="banner">
            <img
              src="https://res.cloudinary.com/doddfudab/image/upload/v1555282138/rtds_work/branding/eats-in-the-west.png"
              alt="banner"
              className="banner"
            />
          </div>
        </div>
        <SubNavBranding />
        {selected[0] ? (
          <Feature
            data={selected[0] ? selected[0].features : []}
            name={selected[0].name}
            desc={selected[0].desc}
          />
        ) : (
          <Feature
            data={clients[0] ? clients[0].features : []}
            name={clients[0].name}
            desc={clients[0].desc}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Branding);



// WEBPACK FOOTER //
// ./src/components/pages/category/Branding.js